import { selectIsMembers } from 'feature/billing/billingSlice';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState } from 'store/store';
import { BillingView } from 'types/Billing';

export const useBillingSubTab = () => {
	const location = useLocation();
	const pathnames = location.pathname.split('/');
	// isMembers is determined purely from the URL path, so it is
	// stable on a hard refresh before Redux state has been initialised.
	const isMembers = pathnames.includes('members');

	// isMembersAggregation: the "admin → members" sub-tab while still on
	// /view-billing (not yet drilled into /view-billing/members).
	const isReduxMembers = useSelector(selectIsMembers);
	const isMembersAggregation = isReduxMembers && !isMembers;

	const view: BillingView = isMembers
		? 'members'
		: isMembersAggregation
			? 'aggregation'
			: 'claims';

	const subTabSelected = useSelector(
		(state: RootState) => state.billing.subTabSelected,
	);

	return { isMembers, isMembersAggregation, subTabSelected, view };
};
